/*　include
------------------------------------------------------- */

import "core-js/stable";
import "regenerator-runtime/runtime";
import './scss/style.scss';

/*
------------------------------------------------------- */

$('.js_menu-btn').click(function() {
    $('.ly_header').toggleClass('DownMove');
    $('html,body').toggleClass('menu-open');
    $(this).toggleClass('fix');
    $('.ly_menu-content').toggleClass('open');
})

$('.js_menu-btn').on('click', function() {
    setTimeout(function(){
      $('.ly_menu-content.fix').removeClass('fix');
    },900);
})

  $('.js_menu-btn').click(function() {
      $('.ly_menu-content').addClass('fix');
  })

if(navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)){
    // スマホ・タブレット（iOS・Android）の場合の処理を記述
    $('body').addClass('sp-tb');
}else{
    // PCの場合の処理を記述
    $('body').addClass('pc');
}

$('.js_menu-btn').click(function() {
    setTimeout(function(){
        $('.ly_menu-content__social').toggleClass('fix');
    },800);
    $('.ly_header').addClass('DownMove');
    $('.ly_header').removeClass('UpMove');
})

$('.js_menu-btn.fix').click(function() {
    $('.ly_header').removeClass('DownMove');
})

/* メニュー */
const ham = document.querySelector('.js_menu-btn');
const menu = document.querySelector('.ly_menu-content');
const links = menu.querySelectorAll('.js_menu-item');

var tl = gsap.timeline({ paused: true });

tl.to(menu, {
    duration: 0.6,
    opacity: 1,
    height: '100vh',
    ease: 'expo.inOut',
})
tl.from(links, {
    duration: 0.7,
    opacity: 0,
    y: 20,
    stagger: 0,
    ease: 'expo.inOut',
}, "-=0.1");

tl.reverse();

ham.addEventListener('click', () => {
    tl.reversed(!tl.reversed());
    console.log('click');
});

  $('.el_splash').addClass("js_hidden");
  $('.wrap').addClass("js_visible");
  $('header').addClass("js_visible");

$(function() {
  $('.js_nijimi-inview').on('inview', function(event, isInView) {
    if (isInView) {
    //表示領域に入った時
      $('.un_delay-01').addClass('img-blur');
      $('.un_delay-02').addClass('img-blur');
      $('.un_delay-03').addClass('img-blur');
      $('.un_delay-04').addClass('img-blur');
    } else {
    //表示領域から出た時
    }
  });
});

$(function(){
    $('.js_nijimi-inview').on('inview', function(event, isInView) {
      if (isInView) {
      //表示領域に入った時
      $('.un_delay-01').delay(1000).queue(function() {
        $(this).addClass('img-blur').dequeue();
      });
      $('.un_delay-02').delay(2000).queue(function() {
        $(this).addClass('img-blur').dequeue();
      });
      $('.un_delay-03').delay(3000).queue(function() {
        $(this).addClass('img-blur').dequeue();
      });
      $('.un_delay-04').delay(4000).queue(function() {
        $(this).addClass('img-blur').dequeue();
      });
      } else {
      //表示領域から出た時
      }
    });
});

$(function(){
    $('.js_nijimi-inview').on('inview', function(event, isInView) {
      if (isInView) {
      //表示領域に入った時
      $('.un_delay-01').delay(1000).queue(function() {
        $(this).addClass('img-blur').dequeue();
      });
      $('.un_delay-02').delay(2000).queue(function() {
        $(this).addClass('img-blur').dequeue();
      });
      $('.un_delay-03').delay(3000).queue(function() {
        $(this).addClass('img-blur').dequeue();
      });
      $('.un_delay-04').delay(4000).queue(function() {
        $(this).addClass('img-blur').dequeue();
      });
      } else {
      //表示領域から出た時
      }
    });
});


var beforePos = 0;//スクロールの値の比較用の設定

//スクロール途中でヘッダーが消え、上にスクロールすると復活する設定を関数にまとめる
function ScrollAnime() {
    var elemTop = $('.header-area').offset().top;//#area-2の位置まできたら
  var scroll = $(window).scrollTop();
    //ヘッダーの出し入れをする
    if(scroll == beforePos) {
    //IE11対策で処理を入れない
    }else if(elemTop > scroll || 0 > scroll - beforePos){
    //ヘッダーが上から出現する
    $('header').removeClass('UpMove'); //#headerにUpMoveというクラス名を除き
    $('header').addClass('DownMove');//#headerにDownMoveのクラス名を追加
    }else {
    //ヘッダーが上に消える
    $('header').removeClass('DownMove');//#headerにDownMoveというクラス名を除き
    $('header').addClass('UpMove');//#headerにUpMoveのクラス名を追加
    }

    beforePos = scroll;//現在のスクロール値を比較用のbeforePosに格納
}

// 画面をスクロールをしたら動かしたい場合の記述
$(window).scroll(function () {
  ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
});

// ページが読み込まれたらすぐに動かしたい場合の記述
$(window).on('load', function () {
  ScrollAnime();//スクロール途中でヘッダーが消え、上にスクロールすると復活する関数を呼ぶ
});

$(function() {
  $('.js_fade-a').on('inview', function(event, isInView) {
    if (isInView) {
    //表示領域に入った時
      $(this).addClass('img-blur');
    } else {
    //表示領域から出た時
    }
  });
});

var swiperThumbnail = new Swiper(".swiperThumbnail", {
      slidesPerView: 5,
      spaceBetween: 8,
      freeMode: true,
      watchSlidesProgress: true,
    });

    var swiperMain = new Swiper(".swiperMain", {
          slidesPerView: 1,
          effect: "fade",
          loop: true,
          speed: 1000,
            autoplay: {
              delay: 2500,
            },
          pagination: {
            el: ".swiper-pagination",
            type: "fraction", // 枚数表示
          },
          navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          thumbs: {
              swiper: swiperThumbnail,
            }
    });

$(function() {
$("li:empty").not(".js_sort_result-right").remove();
});

